module.exports = __webpack_public_path__ + "img/popup-book.c6ed12d0.svg";